type Props = {
  width?: number;
  height?: number;
  color: string;
  className?: string;
};

const ArrowDownIcon = ({ width = 25, height = 24, color, className }: Props) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 -5 24 24" className={className}>
      <title>chevron-down</title>
      <path
        fill={color}
        fill-rule="evenodd"
        d="M23.688.28a1.01 1.01 0 0 0-1.42 0L11.984 11.57 1.702.28a1.01 1.01 0 0 0-1.42 0c-.392.4-.392 1.04 0 1.43l10.943 12.01c.209.21.486.3.759.28.274.02.551-.07.761-.28L23.688 1.71c.391-.39.391-1.03 0-1.43"
      />
    </svg>
  );
};

export default ArrowDownIcon;
